import { useState, forwardRef, useImperativeHandle } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Divider,
  Box,
} from "@mui/material";
import { X } from "@phosphor-icons/react";
import { styled } from "@mui/material/styles";

const PrintingCakePreviewDialog = forwardRef(({ uploadedImage }, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog: () => {
      setOpen(true);
    },
    closeDialog: () => {
      setOpen(false);
    },
  }));

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      onClose={() => setOpen(false)}
      sx={dialogStyles}
    >
      <Box sx={headerContainer}>
        <DialogTitle
          sx={{
            ...titleStyles,

            fontSize: { xs: "16px", sm: "22px" },
          }}
        >
          Your Picture Preview    
        </DialogTitle>
        <IconButton sx={closeButtonStyles} onClick={() => setOpen(false)}>
          <X size={24} />
        </IconButton>
      </Box>
      <Divider sx={{ mt: 1, mx: 3 }} />

      <DialogContent sx={{ p: 3, display: "flex", justifyContent: "center" }}>
        <CartImage src={uploadedImage} alt="UploadedImage" />
      </DialogContent>
    </Dialog>
  );
});

// Styles
const dialogStyles = {
  "& .MuiPaper-root": {
    backgroundColor: "var(--neutral-100)",
    borderRadius: "8px",
  },
};

const headerContainer = {
  display: "flex",
  flexDirection: "row",
  position: "relative",
  alignItems: "center",
  justifyContent: "center",
};

const titleStyles = {
  textAlign: "center",
  fontSize: "28px",
  fontWeight: 600,
  lineHeight: "150%",
  color: "var(--neutral-black)",
};

const closeButtonStyles = {
  color: "var(--neutral-black)",
  position: "absolute",
  right: "24px",
};

const CartImage = styled("img")(({ theme, index }) => ({
  textAlign: "center",
  padding: "2em",
  width: "50%",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    objectFit: "contain",
  },
}));

export default PrintingCakePreviewDialog;
